// extracted by mini-css-extract-plugin
export default {"input":"styles__input___ppkfA","inputWrapper":"styles__inputWrapper___9hpAM","checkLabel":"styles__checkLabel___KDanH"};